import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import FormattedLink from '@stubhub/react-formatted-link';

import {getFooterData} from './footer-links-data';

import '../styles/footer-links.scss';

class FooterLinks extends Component {
  render() {
    const {intl} = this.props;
    const {globalRegistry} = this.context;
    const data = getFooterData(globalRegistry.getStoreId(), intl.locale);

    return data.map((column) => {
      return (
        <div key={column.id} className={`FooterLinks FooterLinks--Column-${column.id}`}>
          <div className="FooterLinks--LinkTitle">{intl.formatMessage(column.message)}</div>
          <ul>
            {column.items.map((item) => {
              return (
                <li key={item.id} className="FooterLinks--LinkItem">
                  {item.id === 'help' ? (
                    item.href.help.noFormat ? (
                      <a href={item.href.help.href} className="FooterLinks-Link" id={item.message.id.toLowerCase()}>
                        {intl.formatMessage(item.message)}
                      </a>
                    ) : (
                      <FormattedLink
                        href={item.href.help.href}
                        className="FooterLinks-Link"
                        id={item.message.id.toLowerCase()}
                      >
                        {intl.formatMessage(item.message)}
                      </FormattedLink>
                    )
                  ) : (
                    <FormattedLink href={item.href} className="FooterLinks-Link" id={item.message.id.toLowerCase()}>
                      {intl.formatMessage(item.message)}
                    </FormattedLink>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      );
    });
  }
}

FooterLinks.propTypes = {
  intl: PropTypes.object,
};

FooterLinks.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default injectIntl(FooterLinks);
